import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelDynamic as _vModelDynamic, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 bg-white add-user-card produit-form" }
const _hoisted_2 = { class: "card-body letter-spacing" }
const _hoisted_3 = { class: "form-section" }
const _hoisted_4 = { class: "row g-3" }
const _hoisted_5 = { class: "col-lg-3 col-md-4" }
const _hoisted_6 = { class: "upload-container" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "text-center px-3"
}
const _hoisted_9 = { class: "col-lg-9 col-md-8" }
const _hoisted_10 = { class: "row g-3" }
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = {
  class: "col-md-4 position-relative",
  ref: "dropdownRef"
}
const _hoisted_15 = {
  key: 0,
  class: "dropdown-menu show suggestions"
}
const _hoisted_16 = {
  class: "dropdown-item",
  href: "javascript:void(0);"
}
const _hoisted_17 = {
  class: "col-md-4 position-relative",
  ref: "dropdownRef1"
}
const _hoisted_18 = {
  key: 0,
  class: "dropdown-menu show suggestions"
}
const _hoisted_19 = {
  class: "dropdown-item",
  href: "javascript:void(0);"
}
const _hoisted_20 = {
  class: "col-md-4 position-relative",
  ref: "dropdownRef2"
}
const _hoisted_21 = {
  key: 0,
  class: "dropdown-menu show suggestions"
}
const _hoisted_22 = {
  class: "dropdown-item",
  href: "javascript:void(0);"
}
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-section" }
const _hoisted_26 = { class: "row g-3" }
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = { class: "col-md-4" }
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = { class: "form-section" }
const _hoisted_31 = { class: "row g-3" }
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = { class: "col-md-4" }
const _hoisted_34 = { class: "col-md-4" }
const _hoisted_35 = { class: "form-section" }
const _hoisted_36 = { class: "row g-3" }
const _hoisted_37 = { class: "col-12" }
const _hoisted_38 = ["onUpdate:modelValue"]
const _hoisted_39 = { class: "form-label-produit" }
const _hoisted_40 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_41 = {
  key: 0,
  class: "d-flex gap-3 pt-1"
}
const _hoisted_42 = { class: "d-flex align-items-center gap-1" }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = { class: "d-flex align-items-center gap-1" }
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = { key: 1 }
const _hoisted_47 = ["onUpdate:modelValue", "name"]
const _hoisted_48 = ["value"]
const _hoisted_49 = ["onUpdate:modelValue", "name"]
const _hoisted_50 = ["value"]
const _hoisted_51 = ["onUpdate:modelValue", "name", "type"]
const _hoisted_52 = {
  key: 3,
  class: "text-danger small"
}
const _hoisted_53 = { class: "form-section" }
const _hoisted_54 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_55 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_56 = {
  class: "nav-link active",
  id: "home-tab",
  "data-bs-toggle": "tab",
  "data-bs-target": "#home-tab-pane",
  type: "button",
  role: "tab",
  "aria-controls": "home-tab-pane",
  "aria-selected": "true"
}
const _hoisted_57 = { class: "badge bg-light text-dark ms-1" }
const _hoisted_58 = {
  class: "tab-content tab-cadre",
  id: "myTabContent"
}
const _hoisted_59 = {
  class: "tab-pane fade show active",
  id: "home-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_60 = { class: "d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = { class: "cond-grid" }
const _hoisted_63 = { class: "col-md-2" }
const _hoisted_64 = ["value"]
const _hoisted_65 = {
  key: 2,
  class: "invalid-feedback d-block"
}
const _hoisted_66 = { class: "col-md-2" }
const _hoisted_67 = ["onUpdate:modelValue"]
const _hoisted_68 = {
  key: 1,
  class: "input-group"
}
const _hoisted_69 = ["onUpdate:modelValue"]
const _hoisted_70 = { class: "input-group-text" }
const _hoisted_71 = {
  key: 2,
  class: "invalid-feedback d-block"
}
const _hoisted_72 = { class: "col-md-2" }
const _hoisted_73 = ["onUpdate:modelValue"]
const _hoisted_74 = ["onUpdate:modelValue"]
const _hoisted_75 = {
  key: 2,
  class: "invalid-feedback d-block"
}
const _hoisted_76 = {
  key: 3,
  class: "invalid-feedback d-block"
}
const _hoisted_77 = { class: "col-md-2" }
const _hoisted_78 = ["onUpdate:modelValue", "onInput"]
const _hoisted_79 = ["onUpdate:modelValue", "onInput"]
const _hoisted_80 = {
  key: 2,
  class: "invalid-feedback d-block"
}
const _hoisted_81 = { class: "col-md-2" }
const _hoisted_82 = ["onUpdate:modelValue"]
const _hoisted_83 = ["onUpdate:modelValue"]
const _hoisted_84 = {
  key: 2,
  class: "invalid-feedback d-block"
}
const _hoisted_85 = {
  key: 3,
  class: "invalid-feedback d-block"
}
const _hoisted_86 = { class: "col-md-2 text-end" }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = {
  class: "tab-pane fade",
  id: "home2-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_89 = { class: "d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3" }
const _hoisted_90 = ["disabled"]
const _hoisted_91 = { class: "product-upload" }
const _hoisted_92 = { class: "dz-message needsclick" }
const _hoisted_93 = {
  key: 0,
  class: "default-image-container"
}
const _hoisted_94 = ["src"]
const _hoisted_95 = { class: "form-actions" }
const _hoisted_96 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_DropZone = _resolveComponent("DropZone")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[56] || (_cache[56] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold mb-1" }, "Ajouter un produit"),
      _createElementVNode("p", { class: "text-muted mb-0 small" }, [
        _createTextVNode("Les champs marqués "),
        _createElementVNode("span", { class: "text-danger" }, "*"),
        _createTextVNode(" sont obligatoires.")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "produitForm",
        onSubmit: _ctx.addProduit,
        "keep-values": _ctx.valuess,
        "validation-schema": _ctx.produitSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("section", _hoisted_3, [
            _cache[29] || (_cache[29] = _createElementVNode("h6", { class: "section-title" }, "Identification", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "form-label-produit" }, "Image principale", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("input", {
                    type: "file",
                    ref: "fileInput",
                    onChange: _cache[0] || (_cache[0] = (event) => _ctx.onFilePrinChange(event)),
                    accept: "image/jpeg, image/png, image/jpg",
                    hidden: ""
                  }, null, 544),
                  _createElementVNode("div", {
                    class: "preview-card",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
                  }, [
                    (_ctx.imagePreview)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.imagePreview,
                          alt: "Image preview"
                        }, null, 8, _hoisted_7))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[18] || (_cache[18] = [
                          _createElementVNode("i", { class: "fa fa-camera preview-icon" }, null, -1),
                          _createElementVNode("div", { class: "fw-medium mt-2" }, "Ajouter une image", -1),
                          _createElementVNode("small", { class: "text-muted" }, "JPG ou PNG", -1)
                        ]))),
                    (_ctx.imagePreview)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          type: "button",
                          class: "delete-btn",
                          title: "Retirer l'image",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeImage && _ctx.removeImage(...args)), ["stop"]))
                        }, _cache[19] || (_cache[19] = [
                          _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                        ])))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label-produit" }, "Code du produit", -1)),
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "code",
                      class: "form-control shadow-none text-black bg-light",
                      readonly: "true",
                      placeholder: "Généré automatiquement"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "code",
                      class: "text-danger small"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[22] || (_cache[22] = _createElementVNode("label", { class: "form-label-produit" }, "Référence usine", -1)),
                    _createVNode(_component_Field, {
                      name: "refProd",
                      type: "text",
                      class: "form-control shadow-none text-black",
                      placeholder: "Entrer la référence"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "refProd",
                      class: "text-danger small"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label-produit" }, [
                      _createTextVNode("Famille "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "famille" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.familleOptions,
                          searchable: true,
                          "track-by": "label",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          onSelect: ($event: any) => (_ctx.selectFamille(field.value)),
                          placeholder: "Sélectionner la famille"
                        }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onSelect"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "famille",
                      class: "text-danger small"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[24] || (_cache[24] = _createElementVNode("label", { class: "form-label-produit" }, [
                      _createTextVNode("Nom du produit "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "nomProd",
                      type: "text",
                      modelValue: _ctx.prodName,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.prodName) = $event)),
                      onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showBox = true)),
                      class: "form-control shadow-none text-black",
                      placeholder: "Entrer le nom du produit"
                    }, null, 8, ["modelValue"]),
                    (_ctx.produitOptions.length > 0 && _ctx.showBox == true)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produitOptions, (produit, index) => {
                            return (_openBlock(), _createElementBlock("li", { key: index }, [
                              _createElementVNode("a", _hoisted_16, _toDisplayString(produit.codeProduit) + " - " + _toDisplayString(produit.nomProd), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ErrorMessage, {
                      name: "nomProd",
                      class: "text-danger small"
                    })
                  ], 512),
                  _createElementVNode("div", _hoisted_17, [
                    _cache[25] || (_cache[25] = _createElementVNode("label", { class: "form-label-produit" }, "Nom standard", -1)),
                    _createVNode(_component_Field, {
                      name: "nomStandar",
                      type: "text",
                      modelValue: _ctx.prodNameS,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.prodNameS) = $event)),
                      onFocus: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showBoxStan = true)),
                      class: "form-control shadow-none text-black",
                      placeholder: "Entrer le nom standard"
                    }, null, 8, ["modelValue"]),
                    (_ctx.produitStanOptions.length > 0 && _ctx.showBoxStan == true)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_18, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produitStanOptions, (produit, index) => {
                            return (_openBlock(), _createElementBlock("li", { key: index }, [
                              _createElementVNode("a", _hoisted_19, _toDisplayString(produit.codeProduit) + " - " + _toDisplayString(produit.nomProd), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ErrorMessage, {
                      name: "nomStandar",
                      class: "text-danger small"
                    })
                  ], 512),
                  _createElementVNode("div", _hoisted_20, [
                    _cache[26] || (_cache[26] = _createElementVNode("label", { class: "form-label-produit" }, "Nom marché", -1)),
                    _createVNode(_component_Field, {
                      name: "nomMarche",
                      type: "text",
                      modelValue: _ctx.prodNameM,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.prodNameM) = $event)),
                      onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showBoxM = true)),
                      class: "form-control shadow-none text-black",
                      placeholder: "Entrer le nom marché"
                    }, null, 8, ["modelValue"]),
                    (_ctx.produitMarOptions.length > 0 && _ctx.showBoxM == true)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_21, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produitMarOptions, (produit, index) => {
                            return (_openBlock(), _createElementBlock("li", { key: index }, [
                              _createElementVNode("a", _hoisted_22, _toDisplayString(produit.codeProduit) + " - " + _toDisplayString(produit.nomProd), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ErrorMessage, {
                      name: "nomMarche",
                      class: "text-danger small"
                    })
                  ], 512),
                  _createElementVNode("div", _hoisted_23, [
                    _cache[27] || (_cache[27] = _createElementVNode("label", { class: "form-label-produit" }, "Unité de stockage", -1)),
                    _createVNode(_component_Field, {
                      name: "uniteStock",
                      modelValue: _ctx.uniteStock,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.uniteStock) = $event))
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.conditionnementOptions,
                          searchable: true,
                          "track-by": "label",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Choisir l'unité de stockage" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "uniteStock",
                      class: "text-danger small"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _cache[28] || (_cache[28] = _createElementVNode("label", { class: "form-label-produit" }, "Unité de gestion", -1)),
                    _createVNode(_component_Field, {
                      name: "uniteGestion",
                      modelValue: _ctx.uniteGestion,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.uniteGestion) = $event))
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.conditionnementgOptions,
                          searchable: true,
                          "track-by": "label",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          onSelect: ($event: any) => (_ctx.seletUniteGestion(field.value)),
                          placeholder: "Choisir l'unité de gestion"
                        }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onSelect"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "uniteGestion",
                      class: "text-danger small"
                    })
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_25, [
            _cache[33] || (_cache[33] = _createElementVNode("h6", { class: "section-title" }, "Gestion du stock", -1)),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[30] || (_cache[30] = _createElementVNode("label", { class: "form-label-produit" }, [
                  _createTextVNode("Méthode de suivi de stock "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "suiviStock",
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      searchable: true,
                      options: ['CUMP', 'FIFO', 'LIFO', 'Par lot'],
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { placeholder: "Sélectionner la méthode" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "suiviStock",
                  class: "text-danger small"
                })
              ]),
              _createElementVNode("div", _hoisted_28, [
                _cache[31] || (_cache[31] = _createElementVNode("label", { class: "form-label-produit" }, [
                  _createTextVNode("Seuil d'alerte "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "seuilAlerte",
                  type: "number",
                  class: "form-control shadow-none text-black",
                  placeholder: "Ex. 10"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "seuilAlerte",
                  class: "text-danger small"
                })
              ]),
              _createElementVNode("div", _hoisted_29, [
                _cache[32] || (_cache[32] = _createElementVNode("label", { class: "form-label-produit" }, [
                  _createTextVNode("Seuil de rupture "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "seuilAppro",
                  type: "number",
                  class: "form-control shadow-none text-black",
                  placeholder: "Ex. 2"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "seuilAppro",
                  class: "text-danger small"
                })
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_30, [
            _cache[37] || (_cache[37] = _createElementVNode("h6", { class: "section-title" }, "Classification et fiscalité", -1)),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _cache[34] || (_cache[34] = _createElementVNode("label", { class: "form-label-produit" }, [
                  _createTextVNode("Pays de fabrication "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "paysProduction",
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.pays,
                      searchable: true,
                      placeholder: "Sélectionner le pays",
                      label: "label",
                      "track-by": "label"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "paysProduction",
                  class: "text-danger small"
                })
              ]),
              _createElementVNode("div", _hoisted_33, [
                _cache[35] || (_cache[35] = _createElementVNode("label", { class: "form-label-produit" }, [
                  _createTextVNode("Groupe de taxe "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "groupe",
                  modelValue: _ctx.groupe,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.groupe) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.groupeOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: _ctx.groupe,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.groupe) = $event))
                    }, field, {
                      placeholder: "Sélectionner un groupe",
                      onSelect: _ctx.onGroupeSelect
                    }), null, 16, ["options", "modelValue", "onSelect"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "groupe",
                  class: "text-danger small"
                })
              ]),
              _createElementVNode("div", _hoisted_34, [
                _cache[36] || (_cache[36] = _createElementVNode("label", { class: "form-label-produit" }, [
                  _createTextVNode("Mode de définition du prix "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "mode",
                  modelValue: _ctx.mode,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.mode) = $event)),
                  readonly: _ctx.estRedonly
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, {
                      options: _ctx.modeOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: _ctx.mode,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.mode) = $event)),
                      disabled: _ctx.estRedonly,
                      placeholder: "Sélectionner le mode",
                      onSelect: _cache[14] || (_cache[14] = (val) => { _ctx.mode = val })
                    }, null, 8, ["options", "modelValue", "disabled"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "readonly"]),
                _createVNode(_component_ErrorMessage, {
                  name: "mode",
                  class: "text-danger small"
                })
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_35, [
            _cache[43] || (_cache[43] = _createElementVNode("h6", { class: "section-title" }, "Description", -1)),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _cache[38] || (_cache[38] = _createElementVNode("label", { class: "form-label-produit" }, "Description du produit", -1)),
                _createVNode(_component_Field, {
                  name: "descProd",
                  as: "textarea",
                  placeholder: "Entrer la description",
                  class: "form-control shadow-none text-black"
                }, {
                  default: _withCtx(({ field }) => [
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control shadow-none text-black",
                      rows: "3",
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                      placeholder: "Entrer la description"
                    }, null, 8, _hoisted_38), [
                      [_vModelText, field.value]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "descProd",
                  class: "text-danger small"
                })
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chamsdescritifs, (champsLibre, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-md-3",
                  key: index
                }, [
                  _createElementVNode("label", _hoisted_39, [
                    _createTextVNode(_toDisplayString(champsLibre.libelleChamp) + " ", 1),
                    (champsLibre.estObligatoire == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_40, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  (champsLibre.typeChamp == 'boolean')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("label", _hoisted_42, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            "onUpdate:modelValue": ($event: any) => ((champsLibre.valeur) = $event),
                            class: _normalizeClass((_ctx.valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-check-input is-invalid' : 'form-check-input'),
                            name: "status",
                            value: "1",
                            checked: ""
                          }, null, 10, _hoisted_43), [
                            [_vModelRadio, champsLibre.valeur]
                          ]),
                          _cache[39] || (_cache[39] = _createTextVNode(" Oui "))
                        ]),
                        _createElementVNode("label", _hoisted_44, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            "onUpdate:modelValue": ($event: any) => ((champsLibre.valeur) = $event),
                            class: _normalizeClass((_ctx.valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-check-input is-invalid' : 'form-check-input'),
                            name: "status",
                            value: "0"
                          }, null, 10, _hoisted_45), [
                            [_vModelRadio, champsLibre.valeur]
                          ]),
                          _cache[40] || (_cache[40] = _createTextVNode(" Non "))
                        ])
                      ]))
                    : (champsLibre.typeChamp == 'name')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          (champsLibre.modeSaisie == 'keywordValueList')
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 0,
                                class: _normalizeClass((_ctx.valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-select shadow-none text-black is-invalid ' : 'form-select shadow-none text-black '),
                                "onUpdate:modelValue": ($event: any) => ((champsLibre.valeur) = $event),
                                name: champsLibre.nomChamp
                              }, [
                                _cache[41] || (_cache[41] = _createElementVNode("option", {
                                  value: "",
                                  disabled: ""
                                }, "Sélectionner", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(champsLibre.valeurPossible, (option, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: index,
                                    value: option.value
                                  }, _toDisplayString(option.libelle), 9, _hoisted_48))
                                }), 128))
                              ], 10, _hoisted_47)), [
                                [_vModelSelect, champsLibre.valeur]
                              ])
                            : _createCommentVNode("", true),
                          (champsLibre.modeSaisie == 'keywordKeyValueList')
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 1,
                                class: _normalizeClass((_ctx.valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-select shadow-none text-black is-invalid ' : 'form-select shadow-none text-black '),
                                "onUpdate:modelValue": ($event: any) => ((champsLibre.valeur) = $event),
                                name: champsLibre.nomChamp
                              }, [
                                _cache[42] || (_cache[42] = _createElementVNode("option", {
                                  value: "",
                                  disabled: ""
                                }, "Sélectionner", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(champsLibre.valeurPossible, (option, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: index,
                                    value: option.valeur
                                  }, _toDisplayString(option.libelle), 9, _hoisted_50))
                                }), 128))
                              ], 10, _hoisted_49)), [
                                [_vModelSelect, champsLibre.valeur]
                              ])
                            : _createCommentVNode("", true)
                        ]))
                      : _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 2,
                          class: _normalizeClass((_ctx.valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1) ? 'form-control shadow-none text-black is-invalid ' : 'form-control shadow-none text-black '),
                          "onUpdate:modelValue": ($event: any) => ((champsLibre.valeur) = $event),
                          name: champsLibre.nomChamp,
                          type: champsLibre.typeChamp
                        }, null, 10, _hoisted_51)), [
                          [_vModelDynamic, champsLibre.valeur]
                        ]),
                  (_ctx.valideteRowProduit(champsLibre.valeur) && champsLibre.estObligatoire == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(champsLibre.libelleChamp) + " est obligatoire. ", 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("section", _hoisted_53, [
            _createElementVNode("ul", _hoisted_54, [
              _createElementVNode("li", _hoisted_55, [
                _createElementVNode("button", _hoisted_56, [
                  _cache[44] || (_cache[44] = _createElementVNode("i", { class: "fa fa-cubes me-1" }, null, -1)),
                  _cache[45] || (_cache[45] = _createTextVNode(" Conditionnements ")),
                  _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.conditionnements.length), 1)
                ])
              ]),
              _cache[46] || (_cache[46] = _createElementVNode("li", {
                class: "nav-item",
                role: "presentation"
              }, [
                _createElementVNode("button", {
                  class: "nav-link",
                  id: "home2-tab",
                  "data-bs-toggle": "tab",
                  "data-bs-target": "#home2-tab-pane",
                  type: "button",
                  role: "tab",
                  "aria-controls": "home2-tab-pane",
                  "aria-selected": "false"
                }, [
                  _createElementVNode("i", { class: "fa fa-picture-o me-1" }),
                  _createTextVNode(" Images ")
                ])
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _cache[48] || (_cache[48] = _createElementVNode("p", { class: "text-muted small mb-0" }, " La première ligne correspond à l'unité de gestion. Ajoutez les autres conditionnements de vente. ", -1)),
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn btn-outline-primary btn-sm", { 'cursor-not-allowed': _ctx.isDisable }]),
                    type: "button",
                    disabled: _ctx.isDisable,
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.addRowConditionnement()))
                  }, _cache[47] || (_cache[47] = [
                    _createElementVNode("i", { class: "fa fa-plus me-1" }, null, -1),
                    _createTextVNode(" Ajouter un conditionnement ")
                  ]), 10, _hoisted_61)
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _cache[50] || (_cache[50] = _createElementVNode("div", { class: "row gx-2 cond-entete d-none d-md-flex" }, [
                    _createElementVNode("div", { class: "col-md-2" }, [
                      _createTextVNode("Conditionnement "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ]),
                    _createElementVNode("div", { class: "col-md-2" }, [
                      _createTextVNode("Quantité "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ]),
                    _createElementVNode("div", { class: "col-md-2" }, [
                      _createTextVNode("Prix min "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ]),
                    _createElementVNode("div", { class: "col-md-2" }, [
                      _createTextVNode("Prix de vente "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ]),
                    _createElementVNode("div", { class: "col-md-2" }, [
                      _createTextVNode("Prix max "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ]),
                    _createElementVNode("div", { class: "col-md-2 text-end" }, "Action")
                  ], -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conditionnements, (conditionnement, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row gx-2 cond-ligne",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_63, [
                        (index == 0)
                          ? (_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "text",
                              readonly: "",
                              value: _ctx.uniteGestion?.split('|')[2],
                              class: "form-control shadow-none text-black bg-light"
                            }, null, 8, _hoisted_64))
                          : (_openBlock(), _createBlock(_component_Multiselect, {
                              key: 1,
                              options: _ctx.conditionnementOptions,
                              searchable: true,
                              "track-by": "label",
                              label: "label",
                              modelValue: conditionnement.conditionnement,
                              "onUpdate:modelValue": ($event: any) => ((conditionnement.conditionnement) = $event),
                              placeholder: "Sélectionner",
                              onSelect: ($event: any) => (_ctx.selectConditionnement(conditionnement.conditionnement, conditionnement))
                            }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onSelect"])),
                        (_ctx.valideteRowProduit(conditionnement.conditionnement))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_65, " Le conditionnement est obligatoire. "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        (index == 0)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "text",
                              readonly: "",
                              "onUpdate:modelValue": ($event: any) => ((conditionnement.quantite) = $event),
                              class: "form-control shadow-none text-black bg-light"
                            }, null, 8, _hoisted_67)), [
                              [_vModelText, conditionnement.quantite]
                            ])
                          : (_openBlock(), _createElementBlock("div", _hoisted_68, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                "onUpdate:modelValue": ($event: any) => ((conditionnement.quantite) = $event),
                                class: _normalizeClass(_ctx.valideteRowProduit(conditionnement.quantite)
                        ? 'form-control shadow-none text-black is-invalid '
                        : 'form-control shadow-none text-black '),
                                placeholder: "Quantité"
                              }, null, 10, _hoisted_69), [
                                [_vModelText, conditionnement.quantite]
                              ]),
                              _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.uniteGestion != null
                        ? (_ctx.uniteGestion?.split("|")[2]) : 'UM'), 1)
                            ])),
                        (_ctx.valideteRowProduit(conditionnement.quantite))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_71, " La quantité est obligatoire. "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        (index == 0)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((conditionnement.prixMin) = $event),
                              class: "form-control shadow-none text-black",
                              placeholder: "Prix min"
                            }, null, 8, _hoisted_73)), [
                              [_vModelText, conditionnement.prixMin]
                            ])
                          : _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 1,
                              type: "number",
                              "onUpdate:modelValue": ($event: any) => ((conditionnement.prixMin) = $event),
                              class: _normalizeClass(_ctx.isPrixMinInvalid(conditionnement)
                        ? 'form-control shadow-none text-black is-invalid'
                        : 'form-control shadow-none text-black'),
                              placeholder: "Prix min"
                            }, null, 10, _hoisted_74)), [
                              [_vModelText, conditionnement.prixMin]
                            ]),
                        (_ctx.isPrixMinInvalid(conditionnement))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_75, " Doit être inférieur ou égal au prix de vente. "))
                          : _createCommentVNode("", true),
                        (_ctx.valideteRowProduit(conditionnement.prixMin))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_76, " Le prix minimal est obligatoire. "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_77, [
                        (index == 0)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((conditionnement.prixVente) = $event),
                              onInput: ($event: any) => (_ctx.calculePrix(conditionnement.prixVente, conditionnement)),
                              class: "form-control shadow-none text-black",
                              placeholder: "Prix de vente"
                            }, null, 40, _hoisted_78)), [
                              [_vModelText, conditionnement.prixVente]
                            ])
                          : _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 1,
                              type: "number",
                              "onUpdate:modelValue": ($event: any) => ((conditionnement.prixVente) = $event),
                              onInput: ($event: any) => (_ctx.calculePrix(conditionnement.prixVente, conditionnement)),
                              class: _normalizeClass(_ctx.valideteRowProduit(conditionnement.prixVente)
                        ? 'form-control shadow-none text-black is-invalid '
                        : 'form-control shadow-none text-black '),
                              placeholder: "Prix de vente"
                            }, null, 42, _hoisted_79)), [
                              [_vModelText, conditionnement.prixVente]
                            ]),
                        (_ctx.valideteRowProduit(conditionnement.prixVente))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_80, " Le prix de vente est obligatoire. "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_81, [
                        (index == 0)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "text",
                              "onUpdate:modelValue": ($event: any) => ((conditionnement.prixMax) = $event),
                              class: "form-control shadow-none text-black",
                              placeholder: "Prix max"
                            }, null, 8, _hoisted_82)), [
                              [_vModelText, conditionnement.prixMax]
                            ])
                          : _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 1,
                              type: "number",
                              "onUpdate:modelValue": ($event: any) => ((conditionnement.prixMax) = $event),
                              class: _normalizeClass(_ctx.isPrixMaxInvalid(conditionnement)
                        ? 'form-control shadow-none text-black is-invalid'
                        : 'form-control shadow-none text-black '),
                              placeholder: "Prix max"
                            }, null, 10, _hoisted_83)), [
                              [_vModelText, conditionnement.prixMax]
                            ]),
                        (_ctx.isPrixMaxInvalid(conditionnement))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_84, " Doit être supérieur ou égal au prix de vente. "))
                          : _createCommentVNode("", true),
                        (_ctx.valideteRowProduit(conditionnement.prixMax))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_85, " Le prix maximal est obligatoire. "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_86, [
                        (index > 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-outline-danger btn-sm",
                              type: "button",
                              title: "Supprimer ce conditionnement",
                              onClick: ($event: any) => (_ctx.removeRowConditionnement(index))
                            }, _cache[49] || (_cache[49] = [
                              _createElementVNode("i", { class: "fa fa-trash-o" }, null, -1)
                            ]), 8, _hoisted_87))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, [
                  _cache[52] || (_cache[52] = _createElementVNode("p", { class: "text-muted small mb-0" }, "Images supplémentaires du produit.", -1)),
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn btn-outline-primary btn-sm", { 'cursor-not-allowed': _ctx.isDisablee }]),
                    type: "button",
                    disabled: _ctx.isDisablee,
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.addRowImage()))
                  }, _cache[51] || (_cache[51] = [
                    _createElementVNode("i", { class: "fa fa-plus me-1" }, null, -1),
                    _createTextVNode(" Ajouter une image ")
                  ]), 10, _hoisted_90)
                ]),
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("div", _hoisted_92, [
                    _createVNode(_component_DropZone, {
                      name: "fichiers[]",
                      maxFilesize: 50000000,
                      maxFiles: Number(10000000000),
                      class: "",
                      uploadOnDrop: true,
                      onAddedFile: _ctx.onFileAdd,
                      onRemovedFile: _ctx.onFileRemove,
                      options: _ctx.dropzoneOptions,
                      onVdropzoneSuccess: _ctx.onSuccess,
                      onVdropzoneError: _ctx.onError
                    }, {
                      default: _withCtx(() => [
                        (!_ctx.hasFiles)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                              _createElementVNode("img", {
                                src: _ctx.defaultImage,
                                alt: "Default",
                                class: "default-image"
                              }, null, 8, _hoisted_94),
                              _cache[53] || (_cache[53] = _createElementVNode("p", { class: "text-muted mb-0" }, "Glissez-déposez vos images ici, ou cliquez pour les sélectionner", -1))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["maxFiles", "onAddedFile", "onRemovedFile", "options", "onVdropzoneSuccess", "onVdropzoneError"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_95, [
            _createVNode(_component_router_link, {
              to: "/produits/liste-produits",
              class: "btn btn-light"
            }, {
              default: _withCtx(() => _cache[54] || (_cache[54] = [
                _createElementVNode("i", { class: "fa fa-arrow-left me-1" }, null, -1),
                _createTextVNode(" Annuler ")
              ])),
              _: 1
            }),
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn-primary", (!_ctx.isDisable || !_ctx.isDisableCha) ? { 'cursor-not-allowed': false } : { 'cursor-not-allowed': true }]),
              type: "submit",
              disabled: (_ctx.isDisable || _ctx.isDisableCha) ? true : false
            }, _cache[55] || (_cache[55] = [
              _createElementVNode("i", { class: "fa fa-check me-1" }, null, -1),
              _createTextVNode(" Enregistrer le produit ")
            ]), 10, _hoisted_96)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "keep-values", "validation-schema"])
    ])
  ]))
}